module.exports = __webpack_public_path__ + "a436855a68c6ae998b5b3c8384d63855.svg";